module.exports = __webpack_public_path__ + "static/media/icon_reminders.264f9dc8.svg";